import { Organization } from '@/types';

export type OrgArchiveFilter = 'active' | 'archived' | 'all';

export const filterOrganizations = (
  orgs: Organization[],
  filter: OrgArchiveFilter,
  searchQuery: string,
): Organization[] => {
  const query = searchQuery.trim().toLowerCase();

  return orgs.filter((org) => {
    const matchesStatus =
      filter === 'all' ||
      (filter === 'archived' ? !!org.archived : !org.archived);
    const matchesSearch = !query || org.name.toLowerCase().includes(query);
    return matchesStatus && matchesSearch;
  });
};
